<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="companies"
      :loading="loading"
      loading-text="Loading companies..."
      no-data-text="No companies found"
      disable-pagination
      hide-default-footer
      class="elevation-1 bgTable"
    >
      <template #item.name="{ item }">
        <v-btn
          color="primary"
          text
          @click="
            $router.push({
              name: 'CompanyPlans',
              params: { id: item.pk, name: item.name }
            })
          "
        >
          {{ item.name }}
        </v-btn>
      </template>

      <template #item.created="{ item }">
        {{ toDatetime(item.created) }}
      </template>

      <template #item.periodTest="{ item }">
        <avs-editButton
          :disabled="item.plan_name != 'Platinum - Trial version'"
          @click.native="handleChosenCompany(item)"
        />
      </template>
      <template #item.is_active="item">
        <v-switch
          v-model="item.item.is_active"
          :label="item.item.is_active ? 'Active' : 'Disabled'"
          @click="handleActivation(item.item)"
        ></v-switch>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogExtend"
      width="500"
      height="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Period test extension
          <v-spacer></v-spacer>
          <v-btn
            fab
            text
            @click="dialogExtend = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
        >
          Extend period testing for 15 days
        </v-card-text>

        <v-card-actions class="justify-center mt-10">
          <v-btn
            :style="{
              backgroundColor: '#59358C',
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10"
            @click="confirmExtension"
          >
            Extend
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogActivation"
      width="500"
      height="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Activation
          <v-spacer></v-spacer>
          <v-btn
            fab
            text
            @click="handleClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          v-if="!chosenCompany.is_active"
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
          >Do you want to disable {{ chosenCompany.name }} and their users ?
        </v-card-text>

        <v-card-text
          v-else
          class="text-h6 text-subtitle font-weight-bold py-2 mt-10"
          align="center"
        >
          Do you want to reactivate {{ chosenCompany.name }} and their users ?
        </v-card-text>

        <v-card-actions class="justify-center mt-10">
          <v-btn
            v-if="!chosenCompany.is_active"
            :style="{
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10 blue white--text"
            @click="confirmActivation"
          >
            Disable
          </v-btn>
          <v-btn
            v-else
            :style="{
              paddingLeft: '80px',
              paddingRight: '80px'
            }"
            text
            x-large
            class="mb-10 blue white--text"
            @click="confirmActivation"
          >
            Reactivate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminServices from "@/services/AdminServices"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "CompaniesPlans",
  data() {
    return {
      headers: [
        { text: "Name", align: "start", sortable: true, value: "name" },
        { text: "Inscription date", align: "center", value: "created" },
        { text: "Projects", align: "center", value: "nb_projects" },
        { text: "Users", align: "center", value: "nb_users" },
        { text: "Operators", align: "center", value: "nb_operators" },
        { text: "Data used", align: "center", value: "data_used" },
        { text: "Status", align: "center", value: "is_active" }
      ],
      companies: [],
      loading: false, // enable to synchronise call Api and the view
      dialogExtend: false,
      dialogActivation: false,
      chosenCompany: { is_active: false }
    }
  },
  mounted() {
    this.loading = true
    AdminServices.getCompanies()
      .then(r => {
        this.companies = r.results
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    toDatetime,
    handleChosenCompany(company) {
      this.chosenCompany = company
      this.dialogExtend = true
    },
    confirmExtension() {
      this.dialogExtend = false
      this.loading = true
      AdminServices.getExtendPlan(this, this.chosenCompany.pk)
      AdminServices.getCompanies()
        .then(r => {
          this.companies = r.results
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * closing dialog activation, handling the is_active attribute of the company
     */
    handleClose() {
      this.dialogActivation = false
      this.chosenCompany.is_active = !this.chosenCompany.is_active
    },
    /**
     * handles the dialog activation with dialogActivation
     * @param company selected company that we want to change activation
     */
    handleActivation(company) {
      this.chosenCompany = company
      this.dialogActivation = true
    },
    /**
     * handles the confirmation of the dialog activation to activate or disable a company
     */
    confirmActivation() {
      const $ = this
      let data = { is_active: this.chosenCompany.is_active }
      AdminServices.updateCompanyStatus($, this.chosenCompany.pk, data).finally(() => {
        this.loading = true
        AdminServices.getCompanies()
          .then(r => {
            this.companies = r.results
          })
          .finally(() => {
            this.loading = false
            this.dialogActivation = false
          })
      })
      this.dialogActivation = false
    }
  }
}
</script>
<style scoped>
.remove-background {
  background-color: transparent;
}
</style>
